
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			benefitCenter:`get /apis/moyin-account/v1/magicBean/benefitConfig/benefitCenter`,
			getCountdownTime:`get /apis/moyin-account/v1/marketingcenter/vip-day/countdown`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"welfareCenterPage"
			})
		}